import { render, staticRenderFns } from "./LibroEssential.vue?vue&type=template&id=9fa61a9c"
import script from "./LibroEssential.vue?vue&type=script&lang=js"
export * from "./LibroEssential.vue?vue&type=script&lang=js"
import style0 from "./LibroEssential.vue?vue&type=style&index=0&id=9fa61a9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports